import _, { cloneDeep } from "lodash";
import * as moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import { compose } from "redux";
import config from "../../constants/config";
import EnumConstants from "../../constants/enum";
import API from "../../container/utils/api";
import UpdateScore from './updateScore';
import LoadingView from '../view/LoadingView';
import UtilService from "../utils/utils";

class ViewMatchScore extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inProgressFrame: 99,
            btnDis: false,
            timeZone: "",
            matchScore: {},
            isUpdateScoreModalOpen: false,
            frameDetails: [],
            preFrameDetails: [],
            breakPlusTitile: "Breaks +30",
            preMatchScore: {},
            timeZoneShort: "",
            customHighBreak: 30,
        };
    }
    async componentDidMount() {
        const { matchDetail, timeZone } = this.props;
        await this.resultModalToggle(true, matchDetail);
        let timeZoneShort = timeZone ? moment.tz(matchDetail.scheduleTime, timeZone).zoneAbbr() : "";
        this.setState({ timeZone, timeZoneShort })
    }
    formatTime = (timestamp) => {
        const { timeZone } = this.state;
        if (timeZone) {
            return moment.tz(timestamp, timeZone).format('h:mm A');
        }
        return moment(timestamp).format('h:mm A');
    }

    formatDuration = (duration) => {
        const durationMoment = moment.duration(duration);
        const hours = durationMoment.hours();
        const minutes = durationMoment.minutes();
        const seconds = durationMoment.seconds();

        let totalMinutes = hours * 60 + minutes;
        let durationString = '';

        let roundMin = 0;
        if (totalMinutes > 0) {
            if (seconds > 0) {
                roundMin = totalMinutes + seconds / 60;
            } else {
                roundMin = totalMinutes;
            }
        }

        if (totalMinutes > 0 || seconds > 0) {
            durationString = totalMinutes === 0 ? `${seconds < 10 ? '0' : ''}${seconds} Sec` : `${(Math.round(roundMin))} Mins`;
        } else {
            durationString = '00 Mins';
        }

        return durationString;
    };


    resultModalToggle = async (event, data) => {
        if (event) {
            let matchId = data.matchId;
            this.getLetestScore(matchId);
            this.setState({
                resultModal: event,
            });
        } else {
            this.props.closeModal();
            this.setState({ resultModal: event })
        }
    }

    getLetestScore = async (matchId) => {
        await API.getRequest(`${config.BASE_URL}/tournament/matchScore/` + matchId).then(
            response => {
                this.setUpFrameDetails(response);
            }
        ).catch(error => {
            let msg = error.response?.data?.message;
            if (error?.response?.status == 400 && msg?.includes("Scoring is not started")) {
                if (!this.props.isEditable) {
                    this.props.closeModal();
                    this.setState({ resultModal: false })
                    toast.warn("The scoring for this match has not yet begun.")
                }
            } else if (error?.response?.status === 404) {
                toast.error(error.response.data.error)
            } else {
                toast.error("Something went wrong.")
            }
            if (this.props.isEditable) {
                this.setUpFrameDetails(undefined);
            }
        }
        )
    }

    setUpFrameDetails = (matchScore) => {
        const { matchDetail, isEditable, highestbreakStart } = this.props;
        const frame = matchDetail.frame ? matchDetail.frame : matchScore?.frameDuration?.length;

        const defaultFrame = {
            frameNumber: null,
            startTime: null,
            endTime: null,
            duration: null,
            scoreBy: null,
            endFrameBy: null,
            statusId: 1,
            player1Score: null,
            player2Score: null,
            player1HighBreaks: [],
            player2HighBreaks: [],
            player1FrameDifference: "",
            player2FrameDifference: "",
            player1Breaks: "",
            player2Breaks: "",
            player1BallPoints: "",
            player2BallPoints: ""
        };

        if (!matchScore) {


            const frameDetails = Array.from({ length: frame }, (_, i) => ({
                ...defaultFrame,
                frameNumber: i + 1
            }));
            const player1FrameDifference = Array.from({ length: frame }, () => '');
            const player2FrameDifference = Array.from({ length: frame }, () => '');
            const updatedMatchScore = { ...matchDetail, scoreBy: "WEB_APP", winner: null }

            this.setState({
                matchDetails: updatedMatchScore,
                matchScore: updatedMatchScore,
                frameDetails,
                preFrameDetails: cloneDeep(frameDetails),
                preMatchScore: cloneDeep(updatedMatchScore),
                player1FrameDifference,
                player2FrameDifference,
                customHighBreak: highestbreakStart ?? 30
            });
            return;
        }

        const { player1Frames, player2Frames, playerName1, playerName2 } = matchScore;
        const winner = player1Frames === player2Frames ? null : (player2Frames > player1Frames ? playerName2 : playerName1);

        if (isEditable) {
            this.onUpdateScorefn(matchScore, false);
        }


        const {player1BallPoints, player2BallPoints, player1FoulEarned, player2FoulEarned, player1FramesScore, player2FramesScore, customHighBreak } = matchScore;
        const frameDetails = [];

        let player1HighBreaks = this.filterHighBreak(matchScore.player1HighBreaks);
        let player2HighBreaks = this.filterHighBreak(matchScore.player2HighBreaks);

        for (let i = 0; i < frame; i++) {
            if (!_.isEmpty(matchScore) && matchScore.frameDuration[i]) {
                const frame = matchScore.frameDuration[i];
                const player1Score = this.getPlayerScores(i, matchScore.player1HighBreaks, player1FoulEarned);
                const player2Score = this.getPlayerScores(i, matchScore.player2HighBreaks, player2FoulEarned);

                frameDetails.push({
                    frameNumber: frame.frameNumber,
                    startTime: frame.startTime,
                    endTime: frame.endTime,
                    duration: frame.frameDuration,
                    scoreBy: frame.scoreBy,
                    endFrameBy: frame.endFrameBy,
                    statusId: frame.frameStatusId,
                    player1Score: player1Score,
                    player2Score: player2Score,
                    player1HighBreaks: player1HighBreaks && player1HighBreaks.length > 0 ? player1HighBreaks[i] : [],
                    player2HighBreaks: player2HighBreaks && player2HighBreaks.length > 0 ? player2HighBreaks[i] : [],
                    player1FrameDifference: frame.frameStatusId === 7 ? '-' : player1Score > player2Score ? '1' : '0',
                    player2FrameDifference: frame.frameStatusId === 7 ? '-' : player2Score > player1Score ? '1' : '0',
                    player1Breaks: player1HighBreaks[i]?.toString(),
                    player2Breaks: player2HighBreaks[i]?.toString(),
                    player1BallPoints: player1BallPoints && player1BallPoints.length > 0 ? player1BallPoints[i] : [],
                    player2BallPoints: player2BallPoints && player2BallPoints.length > 0 ? player2BallPoints[i] : [],
                    player1FoulEarned: player1FoulEarned && player1FoulEarned.length > 0 ? player1FoulEarned[i] : [],
                    player2FoulEarned: player2FoulEarned && player2FoulEarned.length > 0 ? player2FoulEarned[i] : []
                });
            } else {
                frameDetails.push({ ...defaultFrame, frameNumber: i + 1, player1FrameDifference: '', player2FrameDifference: '' });
            }
        }

        let scoreBy = matchScore ? matchScore.scoreBy : (matchDetail.statusId === 1 ? "WEB_APP" : matchDetail.scoreBy);
        let statusId = matchScore ? matchScore.statusId : matchDetail.statusId;
        const updatedMatchDetails = { ...matchDetail, statusId, scoreBy, winner };
        const updatedMatchScore = { ...matchScore, statusId, scoreBy, winner };
        const updatedPreFrameDetails = cloneDeep(frameDetails);
        const updatedPlayer1FrameDifference = player1FramesScore.map((score, i) => (score > this.getPlayerScores(i, player1HighBreaks, player1FoulEarned) ? '1' : '0'));
        const updatedPlayer2FrameDifference = player2FramesScore.map((score, i) => (score > this.getPlayerScores(i, player2HighBreaks, player2FoulEarned) ? '1' : '0'));

        this.setState({
            matchDetails: updatedMatchDetails,
            matchScore: updatedMatchScore,
            frameDetails,
            preFrameDetails: updatedPreFrameDetails,
            preMatchScore: cloneDeep(updatedMatchScore),
            player1FrameDifference: updatedPlayer1FrameDifference,
            player2FrameDifference: updatedPlayer2FrameDifference,
            customHighBreak: customHighBreak ?? 30
        });
    };


    filterHighBreak = (highBreaks) => {
        return highBreaks?.reduce((breaksList, breaksFrame) => {
            if (breaksFrame?.length > 0) {
                const breaks = breaksFrame.filter(brk => !brk?.isDifference).map(brk => brk?.breakPoint);
                breaksList.push(breaks);
            } else {
                breaksList.push([]);
            }
            return breaksList;
        }, []) || [];
    };


    getPlayerScores = (frameNumber, playerHighBreaks, playerFoulEarn) => {
        if (frameNumber == null) return 0;

        const sumScores = (breaks) => {
            return breaks && breaks.length > 0
                ? breaks.reduce((total, brk) => total + (brk?.breakPoint || 0), 0)
                : 0;
        };

        const sumFoul = (breaks) => {
            return breaks && breaks.length > 0
                ? breaks.reduce((total, brk) => total + (brk || 0), 0)
                : 0;
        };

        const highBreakScore = playerHighBreaks && playerHighBreaks[frameNumber] ? sumScores(playerHighBreaks[frameNumber]) : 0;
        const foulEarnScore = playerFoulEarn && playerFoulEarn[frameNumber] ? sumFoul(playerFoulEarn[frameNumber]) : 0;

        return highBreakScore + foulEarnScore;
    };


    getPlayerUpdatedScores = (frameNumber, playerHighBreaks, playerFoulEarn) => {
        if (frameNumber == null) return 0;

        const sumScores = scores => scores ? scores.reduce((total, current) => total + current, 0) : 0;

        const highBreakScore = playerHighBreaks ? sumScores(playerHighBreaks) : 0;
        const foulEarnScore = (playerFoulEarn && playerFoulEarn[frameNumber]) ? sumScores(playerFoulEarn[frameNumber]) : 0;

        return highBreakScore + foulEarnScore;
    };

    onUpdateScorefn = (matchScore, isScoreUpdated) => {
        if (isScoreUpdated && matchScore.statusId == 1) {
            matchScore.statusId = 6;
            matchScore.scoreMode = "SIMPLIFI"
        }
        this.props.onUpdatedScore(matchScore, isScoreUpdated);
        this.setState({
            preFrameDetails: cloneDeep(this.state.frameDetails),
            preMatchScore: matchScore
        })
    }

    filterBreaks = (breaks) => {
        const threshold = this.state.customHighBreak ?? 30;
        return breaks ? breaks.filter(breakValue => breakValue >= threshold) : [];
    };



    toggleUpdateScoreModal = () => {
        this.setState(prevState => ({
            isUpdateScoreModalOpen: !prevState.isUpdateScoreModalOpen
        }));
    }

    updateFrameScoreFn = async (updatedFrameDetails, player, frameNumber, breakNumber) => {
        let matchScore = cloneDeep(this.state.matchScore);
        let matchDetail = cloneDeep(this.state.matchDetails);
        const { scoreMode, statusId, player1FoulEarned, player2FoulEarned, playerName1, playerName2 } = matchScore
        if (updatedFrameDetails) {
            let player1FinalFrames = 0;
            let player2FinalFrames = 0;

            updatedFrameDetails.forEach((frame, index) => {

                const {
                    player1Breaks,
                    player2Breaks,
                    player1BallPoints,
                    player2BallPoints,
                    player1HighBreaks,
                    player2HighBreaks
                } = frame;

                let player1BreaksList = [];
                let player2BreaksList = [];

                if (statusId === 1 || scoreMode === "SIMPLIFI") {
                    player1BreaksList = player1Breaks?.split(',').map(Number) || [];
                    player2BreaksList = player2Breaks?.split(',').map(Number) || [];
                } else if (scoreMode === "NORMAL") {
                    player1BreaksList = player1HighBreaks || [];
                    player2BreaksList = player2HighBreaks || [];

                    if (index === frameNumber && breakNumber !== null && breakNumber !== undefined) {
                        const playerBreaksList = player === "1" ? player1BreaksList : player2BreaksList;
                        const playerBallPoints = player === "1" ? player1BallPoints : player2BallPoints;

                        if ((playerBreaksList && playerBreaksList[breakNumber]) || (playerBreaksList && playerBreaksList[breakNumber] == 0)) {
                            playerBreaksList[breakNumber] = playerBallPoints[breakNumber].reduce((total, current) => total + current, 0);
                        } else {
                            playerBreaksList.push(playerBallPoints[breakNumber].reduce((total, current) => total + current, 0));
                        }
                    }
                }


                let player1Score = 0;
                let player2Score = 0;
                
                if (matchDetail.statusId === 1 || matchDetail.scoreBy === "WEB_APP" || matchDetail.scoreMode === "SIMPLIFI") {
                    player1Score = parseInt(frame?.player1Score) || 0;
                    player2Score = parseInt(frame?.player2Score) || 0;
                } else {
                    player1Score = this.getPlayerUpdatedScores(index, player1BreaksList, player1FoulEarned);
                    player2Score = this.getPlayerUpdatedScores(index, player2BreaksList, player2FoulEarned);
                }     

                const player1FrameDifference = player1Score > player2Score ? '1' : '0';
                const player2FrameDifference = player2Score > player1Score ? '1' : '0';

                player1FinalFrames += player1Score > player2Score ? 1 : 0;
                player2FinalFrames += player2Score > player1Score ? 1 : 0;

                updatedFrameDetails[index] = {
                    ...frame,
                    player1Score,
                    player2Score,
                    player1HighBreaks: player1BreaksList,
                    player2HighBreaks: player2BreaksList,
                    player1FrameDifference,
                    player2FrameDifference
                };
            });

            const winner = player1FinalFrames === player2FinalFrames ? null : (player2FinalFrames > player1FinalFrames ? playerName2 : playerName1);
            const updatedMatchScore = { ...matchScore, player1Frames: player1FinalFrames, player2Frames: player2FinalFrames, winner };
            const updatedMatchDetails = { ...this.state.matchDetails, winner };
            this.setState({
                frameDetails: updatedFrameDetails,
                matchScore: updatedMatchScore,
                matchDetails: updatedMatchDetails
            });
        }

    }

    getHighBreaks = (frame, player) => {
        const playerKey = `player${player}HighBreaks`;
        if (frame && frame[playerKey] && frame[playerKey].length > 0) {
            return this.filterBreaks(frame[playerKey]).join(', ');
        }
        return "";
    }

    changeBreakPlus = () => {
        const { breakPlusTitile } = this.state;
        let breakPlusTitileNew = breakPlusTitile === "Breaks +30" ? "Breaks +50" : "Breaks +30";
        this.setState({ breakPlusTitile: breakPlusTitileNew });
    }

    reloadScore = async (matchId) => {
        this.getLetestScore(matchId);
    }

    onResetUpdatedScoreFn = () => {
        const { preFrameDetails, preMatchScore } = this.state;
        this.setState({ frameDetails: preFrameDetails, matchScore: preMatchScore })
    }


    render() {
        const { frameDetails, matchScore, breakPlusTitile, matchDetails, timeZone, timeZoneShort, customHighBreak } = this.state;
        return (
            frameDetails && frameDetails.length > 0 ?
                <>
                    <div className="results-modal-container d-flex flex-column align-items-center view-result-modal">
                        <button className="close" data-dismiss="modal" aria-label="Close" onClick={() => this.resultModalToggle(false)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="15.121" height="15.121" viewBox="0 0 15.121 15.121">
                                <g id="Group_11060" data-name="Group 11060" transform="translate(-543.377 -229.939)">
                                    <g id="x_1_" data-name="x (1)" transform="translate(544 231)">
                                        <line id="Line_24" data-name="Line 24" x1="13" y2="13" transform="translate(0.438)" fill="none" stroke="#858585" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                                        <line id="Line_25" data-name="Line 25" x2="13" y2="13" transform="translate(0.438)" fill="none" stroke="#858585" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                                    </g>
                                </g>
                            </svg>
                        </button>
                        <div className="title">{matchDetails.matchName}</div>
                        <div className="date-time"><span className="text-light-gray">Scheduled date & time:</span> <span className="text-red">{UtilService.getZonedTime(matchDetails.scheduleTime, timeZone)}</span></div>
                        <div className="table-text">({matchDetails.tableName})</div>
                        <div className="table-container table-responsive tableView custome-reponsive-duration">
                            <table className={`table mb-0 ${matchScore && matchScore.scoreBy === "WEB_APP" ? "remove-firstChild" : ""}`}>
                                <thead>
                                    <tr className="top-head">
                                        <td colSpan="1" className="text-left">
                                            <div className="content-left">
                                                {matchScore && matchScore.scoreBy === "SCORING_APP" &&
                                                    <>
                                                        <div className="player-title match-time">Match Time</div>
                                                        {matchScore.endMatchTime && matchScore.startMatchTime ?
                                                            <>
                                                                <div className="match-duration-time">{matchScore.startMatchTime && this.formatTime(matchScore.startMatchTime)} - {matchScore.endMatchTime && this.formatTime(matchScore.endMatchTime)} {timeZoneShort && <span>({timeZoneShort})</span>}</div>
                                                                <div className="">({this.formatDuration(matchScore.matchDuration)})</div>
                                                            </>
                                                            :
                                                            <div className="mins"> Started at: {matchScore.startMatchTime && this.formatTime(matchScore.startMatchTime)} {timeZoneShort && <span>({timeZoneShort})</span>}</div>
                                                        }

                                                    </>
                                                }
                                            </div>
                                        </td>
                                        <td colSpan="4">
                                            <div className="left-player player-details d-flex flex-column align-items-end">
                                                <div className="d-flex align-items-center info-left">
                                                    <div className="content-left d-flex flex-column align-items-end">
                                                        <div className="player-name">Player A</div>
                                                        <div className="title">{matchDetails.playerName1} </div>
                                                        <div className="country text-right">{matchDetails.player1Country && <span>(</span>}{matchDetails.player1Country}{matchDetails.player1Country && <span>)</span>}</div>
                                                    </div>
                                                    <figure>
                                                        <img src={matchDetails.player1profileImage ? matchDetails.player1profileImage : matchScore && matchScore.player1profileImage} alt=""></img>
                                                    </figure>
                                                </div>
                                            </div>
                                        </td>
                                        <td colSpan="4">
                                            <div className="right-player player-details d-flex flex-column align-items-start">
                                                <div className="d-flex align-items-center info-left">
                                                    <figure>
                                                        <img src={matchDetails.player2profileImage ? matchDetails.player2profileImage : matchScore && matchScore.player2profileImage} alt=""></img>
                                                    </figure>
                                                    <div className="content-right d-flex flex-column align-items-start">
                                                        <div className="player-name">Player B</div>
                                                        <div className="title">{matchDetails.playerName2} </div>
                                                        <div className="country text-left">{matchDetails.player2Country && <span>(</span>}{matchDetails.player2Country}{matchDetails.player2Country && <span>)</span>}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr className="edit-score-row">
                                        {matchScore && matchScore.scoreBy === "WEB_APP" && <td colSpan="1" className="edit-score-cell"></td>}
                                        <td colSpan={`${matchScore && matchScore.scoreBy === "WEB_APP" ? "8" : "9"}`} className="edit-score-cell">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className="edit-scores d-flex align-items-center justify-content-end">
                                                    <div
                                                        className={`edit-icon`}
                                                        onClick={() => this.reloadScore(matchDetails.matchId)}
                                                        title="Click Here! to reload the score"
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 512 512"
                                                            width="24" height="24"
                                                        >
                                                            <path d="M496 72v128C496 213.3 485.3 224 472 224h-128c-13.19 0-24-10.66-24-23.98c0-6.247 2.432-12.39 7.033-16.99L379.2 130.9C346.9 99.29 303.1 80 256 80C158.1 80 80 158.1 80 256s78.97 176 176 176c81.21 0 107.1-46.34 127.1-46.34c10.18 0 24.02 8.003 24.02 24.01c0 25.11-75.1 70.27-152.1 70.27c-123.5 0-223.9-100.4-223.9-223.9s100.4-223.1 223.9-223.1c60.03 0 116 24.58 157.1 64.95l41.1-41.1c4.601-4.601 10.74-7.019 16.99-7.019C485.4 48.01 496 58.83 496 72z" />
                                                        </svg>
                                                        <span> Reload Score</span>
                                                    </div>
                                                </div>

                                                {this.props.isEditable && <div className="edit-scores d-flex align-items-center justify-content-end">
                                                    <div
                                                        className={`edit-icon ${matchScore && matchScore.statusId === EnumConstants.InProgress ? "disabled" : ""}`}
                                                        onClick={matchScore && matchScore.statusId !== EnumConstants.InProgress ? this.toggleUpdateScoreModal : undefined}
                                                        title={matchScore && matchScore.statusId === EnumConstants.InProgress ? "Match score is in progress and cannot be updated" : "Click here to update the match score"}
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 512 512">
                                                            <path d="M454.6 45.3l12.1 12.1c12.5 12.5 12.5 32.8 0 45.3L440 129.4 382.6 72l26.7-26.7c12.5-12.5 32.8-12.5 45.3 0zM189 265.6l171-171L417.4 152l-171 171c-4.2 4.2-9.6 7.2-15.4 8.6l-65.6 15.1L180.5 281c1.3-5.8 4.3-11.2 8.6-15.4zm197.7-243L166.4 243c-8.5 8.5-14.4 19.2-17.1 30.9l-20.9 90.6c-1.2 5.4 .4 11 4.3 14.9s9.5 5.5 14.9 4.3l90.6-20.9c11.7-2.7 22.4-8.6 30.9-17.1L489.4 125.3c25-25 25-65.5 0-90.5L477.3 22.6c-25-25-65.5-25-90.5 0zM80 64C35.8 64 0 99.8 0 144V432c0 44.2 35.8 80 80 80H368c44.2 0 80-35.8 80-80V304c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z" />
                                                        </svg>
                                                        <span>Edit Score</span>
                                                    </div>
                                                </div>}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="w-235">Time</th>
                                        <th className="w-70">Frame</th>
                                        <th className="w-125 cursor-pointer" onClick={this.changeBreakPlus} title="Click here to change Breaks +30 to Breaks +50.">Breaks +{customHighBreak}</th>
                                        <th className="w-85">Score</th>
                                        <th className="w-70">(1/0)</th>
                                        <th className="w-70">(1/0)</th>
                                        <th className="w-85">Score</th>
                                        <th className="w-125 cursor-pointer" onClick={this.changeBreakPlus} title="Click here to change Breaks +30 to Breaks +50.">Breaks +{customHighBreak}</th>
                                        <th className="w-70">Frame</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {frameDetails && frameDetails.length > 0 && frameDetails.map((item, i) => (
                                        <tr className={item.statusId == 7 ? "bgYellowStatus position-relative" : ""} key={i}>

                                            <td className="text-center align-middle font-weight-normal frame-duration-center">
                                                {item.statusId == 7 && <span className="liveBtn Blink"></span>}
                                                {item.scoreBy === 1 && item.startTime && !item.endTime && `Started at: `}
                                                {item.scoreBy === 1 && item.startTime && this.formatTime(item.startTime)}
                                                {item.scoreBy === 1 && item.endTime && ` - ${this.formatTime(item.endTime)}`}
                                                {item.scoreBy === 1 && item.duration != null && ` (${this.formatDuration(item.duration)})`}

                                            </td>
                                            <td>{item.frameNumber}</td>
                                            <td><strong>{this.getHighBreaks(item, 1)}</strong></td>
                                            <td>{item.player1Score}</td>
                                            <td>{item.player1FrameDifference}</td>
                                            <td>{item.player2FrameDifference}</td>
                                            <td>{item.player2Score}</td>
                                            <td><strong>{this.getHighBreaks(item, 2)}</strong></td>
                                            <td>{item.frameNumber}</td>
                                        </tr>
                                    ))}
                                    <tr className="total-score">
                                        <td colSpan="4" className="text-right font-bold">Final score</td>
                                        <td colSpan="3" className="text-right font-bold display-b">Final score</td>
                                        <td className="text-green font-bold">{matchScore.player1Frames}</td>
                                        <td className="text-red font-bold">{matchScore.player2Frames}</td>
                                        <td colSpan="3"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {matchScore && matchScore.statusId == 7 ?
                            <div className='winnerOnly mt-5 mb-4' style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                <span className='text-center no-scoring'>The result is yet to be announced !</span>
                            </div>
                            :
                            (
                                matchScore && matchScore.statusId == 6 &&
                                (matchScore?.refereeName ?
                                    matchScore.winner ?
                                        <div className="d-flex flex-column">
                                            <div className="pt-3 text-center text-style-2">Winner</div>
                                            <div className="p-2 text-center winner-profile text-bold">{matchScore.winner && _.words(matchScore.winner).map(word => _.capitalize(word)).join(' ')}</div>
                                            <span className='bar'></span>
                                            <div className="p-2 text-center referee-profile refereeNms text-bold">{matchScore.refereeName && _.words(matchScore.refereeName).map(word => _.capitalize(word)).join(' ')}</div>
                                            <div className="text-center text-style-1">(Referee)</div>
                                        </div>
                                        :
                                        <div className="d-flex flex-column mt-4">
                                            {matchScore && matchScore.player1Frames === matchScore.player2Frames &&
                                                <div className="p-2 text-center winner-profile text-bold">Match Tie!</div>}
                                            <span className='bar'></span>
                                            <div className="p-2 text-center referee-profile refereeNms text-bold">{matchScore.refereeName && _.words(matchScore.refereeName).map(word => _.capitalize(word)).join(' ')}</div>
                                            <div className="text-center text-style-1">(Referee)</div>
                                        </div>
                                    :
                                    matchScore.winner ?
                                        <div className="d-flex flex-column">
                                            <div className="pt-4 text-center text-style-2">Winner</div>
                                            <div className="p-2 text-center winner-profile text-bold">{matchScore.winner && _.words(matchScore.winner).map(word => _.capitalize(word)).join(' ')}</div>
                                        </div>
                                        :
                                        (matchScore && matchScore.player1Frames === matchScore.player2Frames && <div className='winnerOnly mt-5 mb-4' style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                            <span className="winner-profile text-bold">
                                                Match Tie!
                                            </span>
                                        </div>
                                        )
                                )
                            )

                        }
                        {
                            matchScore.statusId == 1 && (
                                !this.props.isEditable && !matchScore.player1Frames && !matchScore.player2Frames ?
                                    <span className='text-center no-scoring'>Scoring is not started for this match</span> :
                                    <span className='text-center no-scoring'></span>
                            )
                        }
                    </div>
                    {this.state.isUpdateScoreModalOpen &&
                        <>
                            <div className="modal-backdrop show"></div>
                            <UpdateScore
                                onUpdateScoreModal={this.toggleUpdateScoreModal}
                                isUpdateScoreModalOpen={this.state.isUpdateScoreModalOpen}
                                matchDetails={matchDetails}
                                matchScore={matchScore}
                                frameDetails={frameDetails}
                                updateFrameScore={this.updateFrameScoreFn}
                                preFrameDetails={cloneDeep(this.state.preFrameDetails)}
                                preMatchScore={cloneDeep(this.state.preMatchScore)}
                                onResetUpdatedScore={this.onResetUpdatedScoreFn}
                                onUpdateScoreSuccess={this.onUpdateScorefn}
                                timeZone={timeZone}
                            />
                        </>
                    }
                </> :
                <LoadingView />

        );
    }
}

const mapStateToProps = (state) => ({
    countryApiReducer: state.countryApiReducer,
    ui: state.ui,
    apiReducer: state.apiReducer,
});

const mapDispatchToProps = (dispatch) => ({
    dispatch: dispatch,
});

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(ViewMatchScore);
